import { h, Fragment } from "preact";
import { useState, useMemo, useEffect } from "preact/hooks";
import { Search } from "preact-feather";

import WattpadIcon from "../../icons/wattpad.svg";
import AO3Icon from "../../icons/AO3Logo.svg";

import "./browse.scss";
import { showModal } from "../../modal";
import Api from "../../api";

interface IStory {
   id: string;
   author: string;
   title: string;
   summary: string;
   tags: string[];

   provider: "ao3" | "wattpad";
   cover?: string;
}

function showSummaryModal(story: IStory) {
   const controls = showModal(() => {
      const [state, setState] = useState<
         "overview" | "loading" | "error" | "finished"
      >("overview");

      const [error, setError] = useState(undefined);

      useEffect(() => {
         setState("overview");
      }, [story.id]);
      return (
         <Fragment>
            <div className="modal-title">{story.title}</div>
            {state == "overview" && (
               <div className="browse modal-content">
                  <div
                     class="summary"
                     dangerouslySetInnerHTML={{
                        __html: story.summary,
                     }}
                  />

                  <div class="tags">
                     {story.tags.map((e) => (
                        <span>{e}</span>
                     ))}
                  </div>

                  <div>
                     <button
                        class="btn btn-primary"
                        onClick={(evt) => {
                           evt.preventDefault();

                           setState("loading");

                           const then = () => {
                              setState("finished");
                           };

                           const cat = (err: Error) => {
                              console.log(err);
                              setError(err.message);
                              setState("error");
                           };

                           if (story.provider === "ao3") {
                              Api.addAO3(story.id).then(then).catch(cat);
                           } else if (story.provider === "wattpad") {
                              Api.addWattpad(story.id).then(then).catch(cat);
                           }
                        }}
                     >
                        Add to Library
                     </button>
                  </div>
               </div>
            )}

            {state === "loading" && (
               <div className="browse modal-content">Loading...</div>
            )}

            {state === "finished" && (
               <div className="browse modal-content">Finished!</div>
            )}

            {state === "error" && (
               <div className="browse modal-content">Error: {error}</div>
            )}
         </Fragment>
      );
   });
}

function useWorkSearchApi(initalTerm: string) {
   const [term, setTerm] = useState(initalTerm);
   const [page, setPage] = useState(0);

   const [loading, setLoading] = useState(true);
   const [pages, setPages] = useState<IStory[][]>([]);

   useEffect(() => {
      let obsolete = false;
      Promise.resolve().then(async () => {
         setLoading(true);
         while (pages.length < page + 1 && term !== "") {
            console.log("ERASD", page, pages.length);
            const idx = pages.length;
            const res = await fetch(
               `/ao3/works/search?page=${idx}&q=${encodeURIComponent(term)}`
            );
            const data = await res.json();
            if (data.error) return; //TODO: Add error message etc.
            if (obsolete === true) return;
            const ao3 = data.map((s: any) => ({ ...s, provider: "ao3" }));

            const wpres = await fetch(
               `/wattpad/works/search?limit=20&offset=${
                  idx * 20
               }&q=${encodeURIComponent(term)}`
            );

            const wpdata = await wpres.json();
            if (wpdata.error) return; //TODO: Add error message etc.
            if ((obsolete as any) === true) return;
            const wattpad = wpdata.map((s: any) => ({
               ...s,
               provider: "wattpad",
            }));

            let r = [];

            for (let i = 0; i < 20; i++) {
               r.push(ao3[i]);
               r.push(wattpad[i]);
            }

            pages[idx] = r;
         }
         setLoading(false);
      });

      return () => (obsolete = true);
   }, [term, page]);

   return {
      term,
      setTerm: (newTerm: string) => {
         if (term != newTerm) {
            setTerm(newTerm);
            setPage(0);
            setPages([]);
            setLoading(true);
         }
      },
      page,
      pages,
      loading,
      next: () => {
         if (pages.length - 1 >= page) setPage((old) => old + 1);
      },
   };
}

function useInput(initial: string) {
   const [value, setValue] = useState(initial);

   return {
      value,
      onChange: (evt: Event) =>
         setValue((evt.target as HTMLInputElement).value),
   };
}

export default function BrowsePage() {
   const termInput = useInput("");
   const api = useWorkSearchApi(termInput.value);

   return (
      <div class="container browse" style={{ paddingTop: "1rem" }}>
         <div class="elv-4" style={{ display: "flex" }}>
            <input
               class="inp"
               style={{ border: "none", width: "100%" }}
               onKeyUp={(evt) => {
                  if (evt.keyCode === 13) {
                     api.setTerm(termInput.value);
                  }
               }}
               {...termInput}
            />
            <button
               class="btn btn-primary"
               style={{ margin: 0, height: "2rem" }}
               onClick={() => api.setTerm(termInput.value)}
            >
               <Search
                  style={{
                     height: "1rem",
                     width: "1rem",
                     margin: 0,
                     padding: 0,
                  }}
               />
            </button>
         </div>
         {api.pages
            .map((page) =>
               page.map((story) => (
                  <div
                     class="story card"
                     onClick={(evt) => {
                        evt.preventDefault();

                        showSummaryModal(story);
                     }}
                  >
                     <div class="provider">
                        {story.provider == "ao3" ? (
                           <img src={AO3Icon} />
                        ) : (
                           <img src={WattpadIcon} />
                        )}
                     </div>
                     <div class="title">{story.title}</div>
                     <div class="cnt">
                        <div class="cover">
                           {story.cover && <img src={story.cover} />}
                        </div>

                        <div class="text-content">
                           <div class="author">{story.author}</div>
                           <div
                              class="summary"
                              dangerouslySetInnerHTML={{
                                 __html: story.summary,
                              }}
                           />
                        </div>
                     </div>
                  </div>
               ))
            )
            .flat()}
         {api.loading && <div>Loading</div>}
         {!api.loading && (
            <button class="btn" onClick={() => api.next()}>
               More...
            </button>
         )}
      </div>
   );
}
